import 'antd/dist/antd.css';
import './style/single-review.css'
import Rate from 'antd/lib/rate'
import CreateReply from './createReview'
import { connect } from 'react-redux'
import { useState } from 'react'
import axios from '../../../api/python'
import { BASE_URL } from '../../../variables'

const SingleReview = ({  review, renderReviewReply, isReply, authenticated, replyActiveFor, toggleReply}) => {
    const replyCount = review.replies.length
    const [replyList, setReplyList] = useState({active: false, data: null})
    const toggleReplyList = () => {
        if (replyList.data){
            setReplyList(s => {
                return {...s, active: !replyList.active}
            })
        }
        else{
            axios.get(`get_replies/v2/${review.id}/`)
            .then(response => {
                setReplyList({active: !replyList.active, data: response.data})
            })
        }
    }
    return (
        <div className="comment-wrapper">
        <div className="comment">
            <span className="avatar">
                <img src={review.user.photo.startsWith('http') ? review.user.photo : BASE_URL + review.user.photo} alt="employee"/>
            </span>
            <div className="content">
                <span className="author">{review.user.username || review.user.email || review.user.number}</span>
                <div className="metadata">
                    <span className="date">{review.created.trim()}</span>
                </div>
                <Rate disabled defaultValue={review.star} />
                <div className="text">
                    {review.review}
                </div>
                {!isReply && authenticated ? <div className="actions">
                    <span className="reply" onClick={() => toggleReply(review.id)}>Reply</span>
                </div> : ""}
                {!isReply && replyActiveFor === review.id && authenticated ? <CreateReply parent={review.id} isReply="True" /> : ""}
            </div>

            {/* {review.replies.length > 0 && <div className="comments" style={{marginLeft: "30px"}}>
                { !isReply ? renderReviewReply(review.replies) : ""}
            </div>} */}

            {replyCount > 0 && (
                <div className="show_reply">
                    <span className="show_reply_link" onClick={toggleReplyList}>
                        {replyList.active ? (
                            <>
                            <i className="fa fa-caret-up" aria-hidden="true" />
                            <span>Hide {replyCount} {replyCount > 1 ? "Replies" : "Reply"} </span>
                            </>
                            ): (
                                <>
                                <i className="fa fa-caret-down" aria-hidden="true" />
                                <span>Show {replyCount} {replyCount > 1 ? "Replies" : "Reply"}</span>
                                </>
                                )}
                    </span>
                </div>
            )}
            {replyList.active && replyList.data && !isReply && (
                <div className="comments" style={{marginLeft: "30px"}}>
                    {renderReviewReply(replyList.data)}
                </div>
            )}
            {review.added_replies && <div className="comments" style={{marginLeft: "30px"}}>{renderReviewReply(review.added_replies)}</div>}
        </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        authenticated: state.Authentication.loginStatus
    }
}
export default connect(mapStateToProps)(SingleReview)